export default Object.freeze({
  None: 0,
  Minute: 1,
  Hour: 2,
  Day: 3,
  Month: 4,
});
